import { cn } from "@/lib/utils/utils"
import { Spinner } from "@/components/Primitives/Spinner"
import { Text } from "@/components/Primitives/Text/text"

interface LoadingStateProps {
  message?: string
  className?: string
}

export function LoadingState({ message, className }: LoadingStateProps) {
  return (
    <div
      className={cn(
        "p-6 bg-neutral-50 rounded-lg mb-4 flex flex-col items-center justify-center",
        className,
      )}
    >
      <Spinner size="lg" className="mb-4" />
      {message && (
        <Text variant="paragraph" className="text-neutral-500">
          {message}
        </Text>
      )}
    </div>
  )
}
